import moment from 'moment';

(() => {
  class ReprocessFailedRefillController {
    constructor($rootScope, $scope, $timeout, $interval, toastr, Orders, Users, $state, ngDialog) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        toastr,
        Orders,
        Users,
        $state,
        ngDialog,
        prescription: $scope.ngDialogData.prescription,
        visit: $scope.ngDialogData.visit,
        mail_order_id: $scope.ngDialogData.mail_order_id,
        refillDetails: $scope.ngDialogData.RefillDetails,
        charging: false,
        fillCharged: Orders.TOTALFILLS,
        fillSent: Orders.TOTALFILLS
      }); // WE WILL KEEP "refillDetails.fill_date" AS DATE WITHOUT TIME
      // ALSO THE "DATE PICKER" IS RETURNING A DATE TYPE
      // this.refillDetails.fill_date = moment(this.refillDetails.fill_date).format('MM-DD-YYYY');

      var fill_date = this.refillDetails.fill_date.split("-");
      this.refillDetails.fill_date = new Date(parseInt(fill_date[0]), parseInt(fill_date[1]) - 1, parseInt(fill_date[2]));
      this.refillDetails.fill_date.setHours(0, 0, 0, 0);
    }

    close() {
      this.$scope.closeThisDialog(false);
    }

    medicationCharge() {
      var this2 = this;
      var mail_order_id = this.mail_order_id;
      var today = moment().format('YYYY-MM-DD'); // WE WILL KEEP "refillDetails.fill_date" AS DATE WITHOUT TIME
      // ALSO THE "DATE PICKER" IS RETURNING A DATE TYPE

      this.refillDetails.fill_date.setHours(0, 0, 0, 0);
      this.refill_Date = moment(this.refillDetails.fill_date).format('YYYY-MM-DD');
      var fillDetail = {
        "fill_date": this.refill_Date
      };
      this.processing = true;

      if (today <= this2.refill_Date) {
        this2.Orders.updateMailorderFill(mail_order_id, this2.refillDetails.id, fillDetail).then(({
          data
        }) => {
          if (today === this2.refill_Date) {
            this2.Orders.mailorderFillProcess(mail_order_id, this2.refillDetails.id).then(({
              data
            }) => {
              this2.toastr.success("Fill Request were sent successfully.");
              var parameters = {
                dollar_sign: false,
                pill_sign: true,
                new_prescription: false,
                show_prescriber: false,
                include_icon_url: false
              };
              this2.Orders.callSlackToNotify(this2.prescription, parameters, this2.visit);
              this2.processing = false;
              this2.$scope.closeThisDialog(true);
            }).catch(err => {
              this2.toastr.error("Error sending fill request: " + JSON.stringify(err));
              this2.processing = false;
              this2.$scope.closeThisDialog(true);
            });
          } else {
            this2.toastr.success("Fill Request will be processed on " + this2.refill_Date);
            this2.processing = false;
            this2.$scope.closeThisDialog(true);
          }
        }).catch(err => {
          this2.toastr.error("Error updating the mailorder fills: " + JSON.Stringify(err));
          this2.processing = false;
          this2.$scope.closeThisDialog(false);
        });
      } else {
        this2.toastr.error("please check the entered date");
        this2.processing = false;
        this2.$scope.closeThisDialog(false);
      }
    }

  }

  ReprocessFailedRefillController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "toastr", "Orders", "Users", "$state", "ngDialog"];
  angular.module('pims').controller('ReprocessFailedRefillController', ReprocessFailedRefillController);
})();